import { Link } from 'react-router-dom'

// Internal paths use the router; full URLs (set from the dashboard) open in a new tab.
export default function SmartLink({ to, children, ...rest }) {
  if (/^(https?:)?\/\//.test(to || '')) {
    return <a href={to} target="_blank" rel="noreferrer" {...rest}>{children}</a>
  }
  return <Link to={to || '/'} {...rest}>{children}</Link>
}
